import ACTIONS, { FETCH_STATUS } from '../constants';
  
export const resetPasswordRequest = (state) => ({
  type: ACTIONS.USER_RESET_PASSWORD_CALL,
  payload: state,
});

export const resetPasswordAttempt = {
pending: {
  type: ACTIONS.USER_RESET_PASSWORD.PENDING,
  status: FETCH_STATUS.LOADING,
},
success: (data) => ({
  type: ACTIONS.USER_RESET_PASSWORD.SUCCESS,
  data,
  status: FETCH_STATUS.SUCCESS,
}),
error: (error) => ({
  type: ACTIONS.USER_RESET_PASSWORD.ERROR,
  error,
  status: FETCH_STATUS.ERROR,
}),
};

export const userProfileAttempt = {
    pending: {
      type: ACTIONS.USER_PROFILE.PENDING,
      status: FETCH_STATUS.LOADING,
    },
    success: (data) => ({
      type: ACTIONS.USER_PROFILE.SUCCESS,
      data,
      status: FETCH_STATUS.SUCCESS,
    }),
    error: (error) => ({
      type: ACTIONS.USER_PROFILE.ERROR,
      error,
      status: FETCH_STATUS.ERROR,
    }),
};
  
export const userProfileRequest = (state) => ({
    type: ACTIONS.USER_PROFILE_CALL,
    payload: state,
});


export const updateProfileDataAttempt = {
    pending: {
      type: ACTIONS.UPDATE_USER_PROFILE.PENDING,
      status: FETCH_STATUS.LOADING,
    },
    success: (data) => ({
      type: ACTIONS.UPDATE_USER_PROFILE.SUCCESS,
      data,
      status: FETCH_STATUS.SUCCESS,
    }),
    error: (error) => ({
      type: ACTIONS.UPDATE_USER_PROFILE.ERROR,
      error,
      status: FETCH_STATUS.ERROR,
    }),
};
  
export const updateProfileData = (state) => ({
    type: ACTIONS.UPDATE_USER_PROFILE_CALL,
    payload: state,
});

export const updateProfilePictureAttempt = {
    pending: {
      type: ACTIONS.UPDATE_USER_PROFILE_PICTURE.PENDING,
      status: FETCH_STATUS.LOADING,
    },
    success: (data) => ({
      type: ACTIONS.UPDATE_USER_PROFILE_PICTURE.SUCCESS,
      data,
      status: FETCH_STATUS.SUCCESS,
    }),
    error: (error) => ({
      type: ACTIONS.UPDATE_USER_PROFILE_PICTURE.ERROR,
      error,
      status: FETCH_STATUS.ERROR,
    }),
};
  
export const updateProfilePicture = (state) => ({
    type: ACTIONS.UPDATE_USER_PROFILE_PICTURE_CALL,
    payload: state,
});

export const updateWorkingHoursAttempt = {
  pending: {
    type: ACTIONS.UPDATE_WORKING_HOURS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_WORKING_HOURS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_WORKING_HOURS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateWorkingHours = (state) => ({
  type: ACTIONS.UPDATE_WORKING_HOURS_CALL,
  payload: state,
});

export const sortRolesRequestAttempt = {
  pending: {
    type: ACTIONS.SORT_ROLES.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_ROLES.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_ROLES.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortRolesRequest = (state) => ({
  type: ACTIONS.SORT_ROLES_CALL,
  payload: state,
});

export const updateRoleFlagAttempt = {
  pending: {
    type: ACTIONS.ROLES_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.ROLES_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.ROLES_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateRoleFlag = (state) => ({
  type: ACTIONS.ROLES_FLAG_CALL,
  payload: state,
});

export const getRolesAttempt = {
  pending: {
    type: ACTIONS.ROLES.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.ROLES.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.ROLES.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getRoles = (state) => ({
  type: ACTIONS.ROLES_CALL,
  payload: state,
});

export const updaterolePermissionsAttempt = {
  pending: {
    type: ACTIONS.UPDATE_PERMISSIONS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_PERMISSIONS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_PERMISSIONS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updaterolePermissions = (state) => ({
  type: ACTIONS.UPDATE_PERMISSIONS_CALL,
  payload: state,
});

export const createRoleAttempt = {
  pending: {
    type: ACTIONS.CREATE_ROLE.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_ROLE.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_ROLE.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createRoleRequest = (state) => ({
  type: ACTIONS.CREATE_ROLE_CALL,
  payload: state,
});

export const updateRoleAttempt = {
  pending: {
    type: ACTIONS.UPDATE_ROLE.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_ROLE.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_ROLE.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateRoleRequest = (state) => ({
  type: ACTIONS.UPDATE_ROLE_CALL,
  payload: state,
});

export const deleteRoleAttempt = {
  pending: {
    type: ACTIONS.DELETE_ROLE.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_ROLE.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_ROLE.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteRoleRequest = (state) => ({
  type: ACTIONS.DELETE_ROLE_CALL,
  payload: state,
});

export const getPermissionsAttempt = {
  pending: {
    type: ACTIONS.PERMISSIONS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PERMISSIONS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PERMISSIONS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getPermissionsRequest = (state) => ({
  type: ACTIONS.PERMISSIONS_CALL,
  payload: state,
});

export const sortResourceRequestAttempt = {
  pending: {
    type: ACTIONS.SORT_USERS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_USERS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_USERS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortResourceRequest = (state) => ({
  type: ACTIONS.SORT_USERS_CALL,
  payload: state,
});

export const getUsersAttempt = {
  pending: {
    type: ACTIONS.USERS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.USERS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.USERS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getUsers = (state) => ({
  type: ACTIONS.USERS_CALL,
  payload: state,
});

export const updateUserStatusAttempt = {
  pending: {
    type: ACTIONS.UPDATE_USER_STATUS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_USER_STATUS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_USER_STATUS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateUserStatus = (state) => ({
  type: ACTIONS.UPDATE_USER_STATUS_CALL,
  payload: state,
});

export const createUserAttempt = {
  pending: {
    type: ACTIONS.CREATE_USER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_USER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_USER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createUserRequest = (state) => ({
  type: ACTIONS.CREATE_USER_CALL,
  payload: state,
});

export const updateUserAttempt = {
  pending: {
    type: ACTIONS.UPDATE_USER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_USER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_USER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateUserRequest = (state) => ({
  type: ACTIONS.UPDATE_USER_CALL,
  payload: state,
});

export const deleteUserAttempt = {
  pending: {
    type: ACTIONS.DELETE_USER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_USER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_USER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteUserRequest = (state) => ({
  type: ACTIONS.DELETE_USER_CALL,
  payload: state,
});

export const updateUserFlagAttempt = {
  pending: {
    type: ACTIONS.USER_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.USER_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.USER_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateUserFlag = (state) => ({
  type: ACTIONS.USER_FLAG_CALL,
  payload: state,
});

export const getGroupsAttempt = {
  pending: {
    type: ACTIONS.GROUPS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GROUPS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GROUPS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getGroups = (state) => ({
  type: ACTIONS.GROUPS_CALL,
  payload: state,
});
export const updatePermissionStatus = () => ({
  type: ACTIONS.UPDATE_PERMISSION_STATUS,
});

